import { inquiryService } from '../../services/inquiry.service'

const state = {
  inquiries: [],
  loading: false,
  saving: false,
  error: null
}

const getters = {
  openCount (state) {
    return state.inquiries.filter(i => i.status === 'Open').length
  },
  recentOpen (state) {
    return state.inquiries.filter(i => i.status === 'Open').slice(0, 5)
  }
}

const mutations = {
  SET_INQUIRIES (state, inquiries) {
    state.inquiries = inquiries
  },
  SET_LOADING (state, val) {
    state.loading = val
  },
  SET_SAVING (state, val) {
    state.saving = val
  },
  SET_ERROR (state, err) {
    state.error = err
  },
  UPSERT_INQUIRY (state, inquiry) {
    const idx = state.inquiries.findIndex(i => i.id === inquiry.id)
    if (idx >= 0) {
      state.inquiries.splice(idx, 1, inquiry)
    } else {
      state.inquiries.unshift(inquiry)
    }
  },
  REMOVE_INQUIRY (state, id) {
    state.inquiries = state.inquiries.filter(i => i.id !== id)
  }
}

const actions = {
  fetchAll ({ commit }) {
    commit('SET_LOADING', true)
    return inquiryService.getAllInquiries()
      .then(data => {
        commit('SET_INQUIRIES', data)
        commit('SET_LOADING', false)
      })
      .catch(err => {
        commit('SET_ERROR', err)
        commit('SET_LOADING', false)
      })
  },

  create ({ commit }, data) {
    commit('SET_SAVING', true)
    return inquiryService.createInquiry(data)
      .then(inquiry => {
        commit('UPSERT_INQUIRY', inquiry)
        commit('SET_SAVING', false)
        return inquiry
      })
      .catch(err => {
        commit('SET_ERROR', err)
        commit('SET_SAVING', false)
        return Promise.reject(err)
      })
  },

  update ({ commit }, data) {
    commit('SET_SAVING', true)
    return inquiryService.updateInquiry(data)
      .then(inquiry => {
        commit('UPSERT_INQUIRY', inquiry)
        commit('SET_SAVING', false)
        return inquiry
      })
      .catch(err => {
        commit('SET_ERROR', err)
        commit('SET_SAVING', false)
        return Promise.reject(err)
      })
  },

  addAction ({ commit }, data) {
    commit('SET_SAVING', true)
    return inquiryService.addAction(data)
      .then(inquiry => {
        commit('UPSERT_INQUIRY', inquiry)
        commit('SET_SAVING', false)
        return inquiry
      })
      .catch(err => {
        commit('SET_ERROR', err)
        commit('SET_SAVING', false)
        return Promise.reject(err)
      })
  },

  deleteInquiry ({ commit }, id) {
    return inquiryService.deleteInquiry(id)
      .then(() => {
        commit('REMOVE_INQUIRY', id)
      })
  }
}

export const inquiries = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}